import { Component, inject } from '@angular/core';
import { GuidedTourService } from './shared/services/guided-tour/guided-tour.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class AppComponent {
  readonly tourService = inject(GuidedTourService);
  title = 'GoCareMo';
}
